import React from 'react'
import SubLink from '../../Route/SubLink';
import { UserManagerData } from '../../Route/SubLinkJSON';



export const UserManage = () => {

  return (
    <>
      <SubLink sublinks={UserManagerData} />
    </>
  )
}





